/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(data) {
    const formData = new FormData();
    
    // Add basic fields
    formData.append('canned_response[short_code]', data.short_code);
    if (data.content) {
      formData.append('canned_response[content]', data.content);
    }
    
    // Add attachments if any
    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach((attachment, index) => {
        if (attachment instanceof File) {
          // New file upload
          formData.append(`attachments[${index}]`, attachment);
        } else if (attachment.action === 'remove') {
          // Remove existing attachment
          formData.append(`attachments[${index}][action]`, 'remove');
          formData.append(`attachments[${index}][id]`, attachment.id);
        }
      });
    }
    return axios.post(this.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  update(data) {
    const formData = new FormData();
    // Add basic fields
    formData.append('canned_response[short_code]', data.short_code);
    if (data.content) {
      formData.append('canned_response[content]', data.content);
    }
    // Add attachments if any
    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach((attachment, index) => {
        if (attachment instanceof File) {
          // New file upload
          formData.append(`attachments[${index}]`, attachment);
        } else if (attachment.action === 'remove') {
          // Remove existing attachment
          formData.append(`attachments[${index}][action]`, 'remove');
          formData.append(`attachments[${index}][id]`, attachment.id);
        }
      });
    }
    
    return axios.put(`${this.url}/${data.id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CannedResponse();
